
import { Loading } from '@/components/ui/loading';
import { cn } from '@/lib/utils';

interface GlobalLoadingProps {
  isLoading: boolean;
  message?: string;
  overlay?: boolean;
}

export const GlobalLoading = ({ 
  isLoading, 
  message = "Carregando...", 
  overlay = true 
}: GlobalLoadingProps) => {
  if (!isLoading) return null;

  if (overlay) {
    return (
      <div className="fixed inset-0 z-50 bg-background/80 backdrop-blur-sm flex items-center justify-center">
        <div className="bg-card p-6 rounded-lg shadow-lg border">
          <Loading size="lg" text={message} />
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-[200px]">
      <Loading size="lg" text={message} />
    </div>
  );
};

interface PageLoadingProps {
  className?: string;
}

export const PageLoading = ({ className }: PageLoadingProps) => {
  return (
    <div className={cn("flex items-center justify-center min-h-[50vh]", className)}>
      <Loading size="lg" text="Carregando página..." />
    </div>
  );
};
